import { QueryClient } from '@tanstack/react-query';

export const METAL_PRICES_STALE_MS = 5 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: METAL_PRICES_STALE_MS,
      retry: 1,
    },
  },
});

export function metalPricesQueryKey(metals, currency = 'USD') {
  const metalsKey = [...new Set(metals.map((metal) => String(metal).toUpperCase()))]
    .sort()
    .join(',');
  return ['metalPrices', currency, metalsKey];
}
